import React from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = ({ onChatClick }) => {
  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img 
              src="/assets/logo-color.png" 
              alt="Vaulted Mails Logo" 
              className="h-10 w-auto"
            />
          </div>

          {/* Contact Us Button */}
          <Button
            onClick={onChatClick}
            className="bg-[#d28f28] hover:bg-[#b87820] text-white font-semibold px-4 py-2 sm:px-6 sm:py-2 rounded-lg shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl flex items-center gap-2"
          >
            <MessageCircle className="h-4 w-4 sm:h-5 sm:w-5" />
            <span className="hidden sm:inline">Contact Us</span>
            <span className="sm:hidden">Contact</span>
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;